import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonGroup } from "@themesberg/react-bootstrap";

import TsaFundList from "./FundList";
import {  useNavigate, useParams } from "react-router-dom";
import { fetchApi, postApi } from "../../../redux/api";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import CustomTable from "../../../components/CustomTable";
import { Card } from "react-bootstrap";

function FaacTsaFunding({ match }) {
  const history = useNavigate();
  const batch_no = useParams().batch_no;
  const { types } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [tsaFundingList, setTsaFundingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const getTsaAccounts = useCallback(() => {
    setLoading(true); // Set loading state to true when fetching data
    fetchApi(`tsa-account?query_type=summary&types=${types}`)
      .then((data) => {
        if (data.results) {
          setTsaFundingList(data.results);
          setLoading(false); // Set loading state to false when data is fetched
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false); // Set loading state to false on error
      });
  }, [types]);

  useEffect(() => {
    getTsaAccounts();
  }, [getTsaAccounts]);

  const getList = () => {
    setLoading(true);
    postApi("select_mda_bank_details", {
      query_type: "select",
    })
      .then((data) => {
        console.log(data);
        setDetails(data.result);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getList();
  }, []);



  let rows = [];

  tsaFundingList &&
    tsaFundingList.forEach((item) => {
      if (
        item.funding_code &&
        item.funding_code.toLowerCase().indexOf(searchTerm) === -1 &&
        item.total_amount.indexOf(searchTerm) === -1 &&
        item.total_amount.toLowerCase().indexOf(searchTerm) === -1
      ) {
        return;
      }

      rows.push(item);
    });
      const fields = [
        {
          title: "Account Number",
          value: "account_number",
        },
        {
          title: "Account Name",
          value: "account_name",
        },
        {
          title: "Bank name",
          value: "bank_name",
        },
        {
          title: "Sort code",
          value: "sort_code",
        },
        {
          title: "Account type",
          value: "account_type",
        },
        {
          title: "Balance",
          tableHeadStyle: { textAlign: "right", color: "black" },
          custom: true,
          component: (item) => (
            <div style={{ textAlign: "right" }}>
              {formatNumber(item.balance)}
            </div>
          ),
        },
        {
          title: "Action",
          custom: true,
          component: (item, index) => (
            <div className="text-center">
              <Button
                item={item}
                onClick={() =>
                  history(
                    `${Routes.tsafunding.fundingReport}/${item.account_number}/${item.account_name}`
                  )
                }
                className="bg-success w-110 text-white"
                size="sm"
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                View
              </Button>
              {/* <Button
                color="success"
                size="sm"
                className="ms-1 bg-success"
                // onClick={() => {
                //   setSelected(item);
                //   setShowWarning(true);
                // }}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  className="text-danger me-1 bg-success"
                />{" "}
                Delete
              </Button> */}
            </div>
          ),
        },
      ];
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <Button
          className="me-2 bg-success border-none"
          onClick={() => history(`${Routes.tsafunding.newfunding}/${types}`)}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Funding
        </Button>
        <div className="d-block mb-4 mb-md-0">
          <h4>{types}</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">
              Share
            </Button>
            <Button variant="outline-primary" size="sm">
              Export
            </Button>
          </ButtonGroup>
        </div>
      </div>
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <CustomTable fields={fields} data={details} isLoading={loading} />
      </Card>
      {/* <TsaFundList list={rows} isLoading={loading} />{" "} */}
      {/* Pass loading state to TsaFundList */}
    </>
  );
}

export default FaacTsaFunding;
